import Notification from './Notification.js';

export default class VideoNotification extends Notification {
    static createFromDateText(dateText) {
        const today = new Date().toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
        const ctaLabel = dateText === today ? "Watch Today's Live Video" : 'Watch The Most Recent Video';
        const dateSlug = dateText.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        return new VideoNotification(
            `video-${ dateSlug }`,
            'video',
            `Motley Fool Live: ${ dateText }`,
            Date.now(),
            '/premium/video/',
            ctaLabel,
        );
    }

    static fromSchedule() {
        const startTime = window.foolNotificationBell?.videoSchedule?.[0]?.startTime;
        if (!startTime) {
            return null;
        }
        const dateText = new Date(startTime).toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
        return VideoNotification.createFromDateText(dateText);
    }

    static async fetch() {
        const fromSchedule = VideoNotification.fromSchedule();
        if (fromSchedule) {
            return [fromSchedule];
        }
        try {
            const url = new URL('/premium/wp-json/wp/v2/pages', window.location.origin);
            url.searchParams.set('per_page', '1');
            url.searchParams.set('slug', 'video');
            url.searchParams.set('_fields', 'content');

            const response = await fetch(url, {
                headers: {
                    "X-WP-Nonce": window.foolNotificationBell.restApiNonce ?? '',
                },
            });
            if (!response.ok) {
                return [];
            }
            const pages = await response.json();
            const html = pages[0]?.content?.rendered;
            if (!html) {
                return [];
            }
            const dateText = new DOMParser()
                .parseFromString(html, 'text/html')
                .querySelector('h3.wp-block-heading')
                ?.textContent
                ?.trim();
            if (!dateText) {
                return [];
            }
            return [VideoNotification.createFromDateText(dateText)];
        } catch (error) {
            console.error(error.message);
        }
        return [];
    }
}
